import {
  LocalizationProvider,
  MobileDatePicker,
} from "@mui/x-date-pickers-pro";
import { TextField, useTheme } from "@mui/material";

import AdapterJalaali from "@date-io/jalaali";

function DatePicker({ value, onChange }) {
  const theme = useTheme();

  return (
    <LocalizationProvider dateAdapter={AdapterJalaali}>
      <MobileDatePicker
        inputFormat="jYYYY/jMM/jDD"
        renderInput={(params) => (
          <TextField placeholder="YYYY/MM/DD" {...params} />
        )}
        DialogProps={{
          PaperProps: {
            sx: {
              ".MuiButtonBase-root": {
                color: theme.palette.text.main,
              },
            },
          },
        }}
        showToolbar={false}
        value={value}
        closeOnSelect
        onChange={onChange}
      />
    </LocalizationProvider>
  );
}

export default DatePicker;
